<div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
        <div class="w-100 text-center">
            <div class="animation-img-container">
                <img src="assets/images/logo/logo.png" class="img-fluid" alt="BECentral-icon"
                    [@tenantSwitchingTrigger]="imageStatus" (@tenantSwitchingTrigger.done)="onAnimationDone($event)" />
            </div>
        </div>
    </div>
</div>